import React from "react";
import { FC, ReactNode } from "react";
import Dialog from "@mui/material/Dialog";
import Fade from "@mui/material/Fade";
import { TransitionProps } from "@mui/material/transitions";
import Close2Icon from "../public/icon/close2.svg";
import classNames from "classnames";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Fade ref={ref} timeout={3000} {...props} />;
});

export type ModalProps = {
  children?: ReactNode;
  className?: string;
  closeIcon?: ReactNode;
  onClose?(): void;
  style?: object;
};

export const CloseIcon2 = ({ className = "", ...rest }) => {
  return (
    <div
      className={classNames(
        "w-[32px] h-[32px] rounded-full border-dashed border border-[#efefef] relative flex items-center justify-center bg-white",
        className
      )}
      {...rest}
    >
      <Close2Icon />
      <div className="absolute top-[-1px] left-[-1px] w-[32px] h-[32px] rounded-full bg-[rgba(0,0,0,.2)] opacity-0 transition hover:opacity-100"></div>
    </div>
  );
};

export const Modal: FC<ModalProps> = ({
  children,
  className = "",
  closeIcon = null,
  onClose,
  style,
}) => {
  return (
    <Dialog open TransitionComponent={Transition}>
      <div
        className={`fixed left-[50%] top-[50%] -translate-y-[50%] -translate-x-[50%] bg-white outline-none rounded-[48px] overflow-hidden ${className}`}
        style={style}
      >
        {children}

        <div
          className="absolute right-[28px] top-[28px] w-[32px] cursor-pointer"
          onClick={onClose}
        >
          {closeIcon || <CloseIcon2 />}
        </div>
      </div>
    </Dialog>
  );
};
